import { ReactComponent as Lock } from '../../assets/Icons/adornments/Lock.svg';
import { ReactComponent as Eye } from '../../assets/Icons/adornments/Eye.svg';
import { ReactComponent as Check } from '../../assets/Icons/adornments/Check.svg';
import { Fragment, MouseEvent } from 'react';

export default function PopupSideNav({
    items,
}: {
    items: {
        label: string,
        type: 'number' | 'view',
        isDisabled: boolean,
        isActive: boolean,
        isComplete: boolean,
        action: (e: MouseEvent<HTMLButtonElement>) => void,
    }[],
    selectedIndex: number,
}) {
    return (
        <div className="w-full max-w-[350px] flex flex-col justify-start items-start p-6">
            {items.map((item, i) => (
                <Fragment key={i}>
                    <button onClick={item.action} disabled={item.isDisabled} className={`w-full px-2 flex justify-start items-center gap-4 rounded-lg ${item.isDisabled ? 'hover:bg-none' : item.isActive ? 'hover:bg-outline/[0.2]' : 'hover:bg-outline/[0.1]'} ${item.isActive ? 'border border-outline bg-outline/[0.2]' : 'border-none bg-none'}`}>
                        <div className={`h-full aspect-square flex justify-center items-center rounded-full border ${(item.isActive || item.isComplete) ? 'border-primary' : 'border-outline'}`}>
                            {item.isDisabled ? (
                                <div className='w-[24px] h-[24px] text-disable'><Lock/></div>
                            ) : item.isComplete ? (
                                <div className='w-[24px] h-[24px] text-primary'><Check/></div>
                            ) : item.type === 'number' ? (
                                <p className={`text-[16px] text-default ${item.isActive ? 'font-semibold' : 'font-medium'}`}>{i+1}</p>
                            ) : (
                                <div className='w-[24px] h-[24px] text-default'><Eye/></div>
                            )}
                        </div>
                        <p className={`text-nowrap text-[16px] py-3 ${item.isActive ? 'font-semibold' : 'font-medium'} ${item.isDisabled ? 'text-disable' : item.isComplete ? 'text-primary' : 'text-default'}`}>{item.label}</p>
                    </button>
                    {i < items.length-1 && (
                        <div className={`w-[32px] border-r h-[24px] ${item.isComplete ? 'border-primary' : 'border-outline'}`}></div>
                    )}
                </ Fragment>
            ))}
        </div>
    )
}